import { render } from "./AppSmall.vue?vue&type=template&id=48c9fbef&scoped=true"
import script from "./AppSmall.vue?vue&type=script&lang=js"
export * from "./AppSmall.vue?vue&type=script&lang=js"

import "./AppSmall.vue?vue&type=style&index=0&id=48c9fbef&scoped=true&lang=css"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c9fbef"]])

export default __exports__